import React from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import { FormikCheckbox } from "@qgiv/core-donor";
import ConnectedMailingAddressPreview from "./ConnectedMailingAddressPreview";
import ConnectedShippingFields from "../Pages/PaymentPage/ConnectedShippingFields";

const ShippingAddress = ({
    additionalText = "",
    controlId,
    displayShippingAddress,
    shipToAddressCheckboxLabel = "Ship add-ons to my mailing address",
    sectionHeading = "Shipping Details",
}) => {
    const { values } = useFormikContext();
    const { Shipping_Address_Use_Mailing = true } = values;

    return (
        displayShippingAddress && (
            <div className="grid">
                <div className="col col--12">
                    <h3>{sectionHeading}</h3>
                    {additionalText && <p>{additionalText}</p>}
                    <FormikCheckbox
                        id="Shipping-Address-Use-Mailing"
                        name="Shipping_Address_Use_Mailing"
                    >
                        {shipToAddressCheckboxLabel}
                    </FormikCheckbox>
                    <div className="grid">
                        {Shipping_Address_Use_Mailing ? (
                            <div className="col col--12 col--md-6 col--no-top-gutter">
                                <ConnectedMailingAddressPreview />
                            </div>
                        ) : (
                            <div className="col col--12 col--no-top-gutter">
                                <ConnectedShippingFields
                                    controlId={controlId}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    );
};

ShippingAddress.propTypes = {
    additionalText: PropTypes.string,
    controlId: PropTypes.number.isRequired,
    sectionHeading: PropTypes.string.isRequired,
    displayShippingAddress: PropTypes.bool.isRequired,
    shipToAddressCheckboxLabel: PropTypes.string,
};

export default ShippingAddress;
